import loadable from "@loadable/component";

const BrandsPageRoute = loadable(() =>
  import(
    /* webpackPreload: true, webpackChunkName: "BRANDS_PAGE" */ "../BrandsPage"
  )
);

export default BrandsPageRoute;
